export const config = {
    animationDuration: 200,
    defaultHideDelay: 500,
};
